var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "53",
      "height": "74"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke-width": "1.3"
    }
  }, [_c('path', {
    attrs: {
      "stroke": "#005149",
      "d": "M51.298 72.4H1.394a.73.73 0 0 1-.731-.729V1.387a.73.73 0 0 1 .731-.728h49.904c.404 0 .73.325.73.728V71.67a.73.73 0 0 1-.73.728z"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#24BA80",
      "d": "M9.952 39.79h32.787V19.139H9.952zm7.104-13.044h18.58m-18.58 5.435h18.58"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }